import { useEffect, useState } from 'react';

import { productionApi } from 'api/production';

/**
 * Fetches and manages carousels.
 *
 * @param {string} packGroupID - The pack group ID.
 * @param {string} filter - The filter to apply to the carousels ("", "aisle", or "featured")
 * @returns {Object} - Hook return object
 * @returns {boolean} loading - Whether the carousels are loading
 * @returns {Array} carousels - The list of carousels
 * @returns {Function} refetch - Function to manually refetch carousels
 * @returns {Function} refetch.silent - Pass true to refetch without updating loading state
 */
export function useCarousels(packGroupID, filter = '') {
    const [loading, setLoading] = useState(true);
    const [carousels, setCarousels] = useState();

    const fetchCarousels = async (silent = false) => {
        try {
            if (!packGroupID) return;

            if (!silent) {
                setLoading(true);
            }

            const response = await productionApi.getCarousels(packGroupID, false, filter);
            const filteredCarousels = response.data?.carousels.filter((carousel) => carousel.version === 2);
            setCarousels(filteredCarousels);
        } catch (error) {
            console.error('Error fetching carousels:', error);
        } finally {
            if (!silent) {
                setLoading(false);
            }
        }
    };

    const refetch = (silent) => {
        fetchCarousels(silent);
    };

    useEffect(() => {
        fetchCarousels();
    }, [packGroupID]);

    return { carousels, loading, refetch };
}
